import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="flex w-full flex-col">
      <div className="px-6 py-4">
        <SkeletonBlock className="h-[25px] rounded-lg" />
      </div>
      <div className="flex flex-col gap-3 px-6">
        <SkeletonBlock className="h-12 rounded-lg" />
        <SkeletonBlock className="h-12 rounded-lg" />
        <SkeletonBlock className="h-12 rounded-lg" />
      </div>
    </div>
  )
}
